import { ConversionBlock } from '@/entities/conversion'
import PauseIcon from '@/shared/assets/icons/pause.svg?react'
import PlayIcon from '@/shared/assets/icons/play.svg?react'
import TrashIcon from '@/shared/assets/icons/trash.svg?react'
import { BaseButton, BaseCard } from '@/shared/components'
import { formatterRubWithCurrency } from '@/shared/utils'
import { EnrichedPaymentRequisiteModel, PaymentRequisiteToStatus } from '@/entities/paymentRequisit'
import { PaymentRequisitIcon } from '../paymentRequisitIcon'
import { RequisitVerify } from '@/entities/requisit/ui/RequisitVerify.tsx'
import { RequisiteModel } from '@/features/requisites'

type Props = {
  paymentRequisit: EnrichedPaymentRequisiteModel
  maxDailyLimit: number
  requesit?:RequisiteModel
}

export const PaymentRequisitMobileBlock = ({ paymentRequisit, maxDailyLimit,requesit }: Props) => {
  const isActive = !paymentRequisit.isDisabledByUser && !paymentRequisit.isBlocked

  return (
    <BaseCard className="md:hidden mb-4 last:mb-0 px-5 text-sm">
      <div className="flex justify-between mb-4 pb-4 border-b border-b-card-border dark:border-b-card-border-dark">
        <div className="flex items-center gap-3">
          <PaymentRequisitIcon
            accountType={paymentRequisit.requisitType}
            status={isActive ? PaymentRequisiteToStatus.Active : PaymentRequisiteToStatus.Disabled}
          />
          <div className="flex flex-col">
            <span className="font-medium">{paymentRequisit.value}</span>
            {/* <span className="text-text-secondary text-sm">{paymentRequisit.id}</span> */}
          </div>
        </div>
        <div className="flex gap-3">
          <BaseButton
            variant="ghost"
            size="icon"
            onClick={() => console.log(`Изменение статуса: ${paymentRequisit.id}`)}
          >
            {isActive ? (
              <PauseIcon className="text-primary dark:text-primary-dark" />
            ) : (
              <PlayIcon className="text-primary dark:text-primary-dark" />
            )}
          </BaseButton>

          <BaseButton
            variant="ghost"
            size="icon"
            onClick={() => console.log(`Удаление аккаунта: ${paymentRequisit.id}`)}
          >
            <TrashIcon className="text-error" />
          </BaseButton>
        </div>
      </div>
      <div className="flex flex-col gap-y-2 mb-[10px]">{requesit?
        <RequisitVerify
          paymentRequisit={paymentRequisit}
          requesit={requesit}
        />
        :<></>
      }</div>
      <div className="flex flex-col gap-y-2 mb-[10px]">
        <span className="text-text-secondary">Суточный лимит</span>
        <div className="font-medium">
          {paymentRequisit.dailyStats?.amountInRub ?? 0} /{' '}
          <span className="text-text-secondary">
            {formatterRubWithCurrency.format(maxDailyLimit)}
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-y-2 mb-[10px]">
        <span className="text-text-secondary">Общий оборот</span>
        <div className="font-medium">
          {formatterRubWithCurrency.format(paymentRequisit.totalStats?.amountInRub ?? 0)}
        </div>
      </div>

      <div className="flex flex-col gap-y-2">
        <span className="text-text-secondary">Конверсия</span>
        <ConversionBlock
          current={paymentRequisit.dailyStats?.counterInSuccess ?? 0}
          goal={paymentRequisit.dailyStats?.counterIn ?? 0}
        />
      </div>
    </BaseCard>
  )
}
